import {usePortfolio} from '#/hooks/use-portfolio';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent, createContext} from 'react';
import {Hex} from 'viem';

interface PortfolioAccountContextValue {
  account: Hex;
  isCurrentUser: boolean;
  portfolioQuery: ReturnType<typeof usePortfolio>;
}

const initialValue: PortfolioAccountContextValue = {} as PortfolioAccountContextValue;
export const PortfolioAccountContext = createContext<PortfolioAccountContextValue>(initialValue);

export const PortfolioAccountContextProvider: FunctionComponent<
  Omit<PortfolioAccountContextValue, 'portfolioQuery'> & DefaultChildren
> = ({children, account, isCurrentUser}) => {
  const portfolioQuery = usePortfolio(account);

  return (
    <PortfolioAccountContext.Provider value={{account, isCurrentUser, portfolioQuery}}>
      {children}
    </PortfolioAccountContext.Provider>
  );
};
